import { useTheme } from '@emotion/react';
import { rgba } from 'polished';
import React, { ComponentProps } from 'react';

import { Overlay as BlocksOverlay } from '~/components/blocks';

type Props = ComponentProps<typeof BlocksOverlay>;

export const Overlay = (props: Props) => {
  const theme = useTheme();

  return (
    <BlocksOverlay
      {...props}
      backgroundColor={rgba(theme.colors.background.patientCyanBlue, 0.3)}
    />
  );
};
